import React, { useMemo } from "react";
import { Box, Tabs, Tab, IconButton, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";

function clampToMonth(monthDate) {
  return dayjs(monthDate).startOf("month").toDate();
}

function monthLabel(monthDate) {
  return dayjs(monthDate).format("YYYY-MM");
}

export function FinanceToolbar({
  monthDate,
  onPrevMonth,
  onNextMonth,
  preset,
  onChangePreset,
  startDate,
  endDate,
  onChangeStart,
  onChangeEnd,
}) {
  const monthText = useMemo(() => monthLabel(monthDate), [monthDate]);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
      {/* Left: Month switcher */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          border: "1px solid #eee",
          borderRadius: 2,
          px: 1,
          py: 0.5,
          gap: 1,
          bgcolor: "#fff",
        }}
      >
        <IconButton size="small" onClick={onPrevMonth}>
          <ChevronLeftIcon fontSize="small" />
        </IconButton>
        <Typography sx={{ fontWeight: 600 }}>{monthText}</Typography>
        <IconButton size="small" onClick={onNextMonth}>
          <ChevronRightIcon fontSize="small" />
        </IconButton>
      </Box>

      {/* Center: Tabs */}
      <Box sx={{ flex: 1, minWidth: 280 }}>
        <Tabs
          value={preset}
          onChange={(_, v) => onChangePreset(v)}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab value="this_month" label="Este mes" />
          <Tab value="last_month" label="El mes pasado" />
          <Tab value="last_6_months" label="Últimos 6 meses" />
          <Tab value="last_year" label="Último año" />
          <Tab value="custom" label="Personalizado" />
        </Tabs>
      </Box>

      {/* Right: Date range */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <DatePicker
          selected={startDate}
          onChange={(d) => onChangeStart(d)}
          dateFormat="dd/MM/yyyy"
          onCalendarOpen={() => preset !== "custom" && onChangePreset("custom")}
        />
        <Typography sx={{ opacity: 0.6 }}>-</Typography>
        <DatePicker
          selected={endDate}
          onChange={(d) => onChangeEnd(d)}
          dateFormat="dd/MM/yyyy"
          onCalendarOpen={() => preset !== "custom" && onChangePreset("custom")}
        />
      </Box>
    </Box>
  );
}
